import React from 'react';
import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import SweetAlert from '../../../../Components/Alerts/SweetAlert';
import { VALID_FILE_EXTENSIONS } from '../../Pqr_enums';
import clsx from 'clsx';
import AttachmentInput from './AttachmentInput/AttachmentInput';
import { maxMBSizePqrFiles } from '../../../../Configs/general';

const AttachmentListSection = ({
  classes,
  fileInputId,
  files,
  setFiles,
  totalSize,
  setTotalSize,
  attachmentSetupList
}) => {
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));
  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.title}>Anexos</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        className={clsx(
          classes.inputContainerItem,
          classes.sweetAlertContainer
        )}
      >
        <SweetAlert
          id="Pqr_Contact_alert"
          type="info"
          noIcon={isMobileSize}
          message={
            <>
              Archivos permitidos:{' '}
              {VALID_FILE_EXTENSIONS.map(ext => ` .${ext}`)}.
              <br />
              Tamaño total de los archivos: {totalSize} MB/{maxMBSizePqrFiles}{' '}
              MB
            </>
          }
          classes={{
            root: classes.sweetAlert,
            message: classes.sweetAlertText
          }}
        />
      </Grid>
      {attachmentSetupList.map((attachment, index) => (
        <Grid item xs={12} key={index} className={classes.inputContainerItem}>
          <AttachmentInput
            {...attachment}
            index={index}
            classes={classes}
            fileInputId={fileInputId}
            files={files}
            totalSize={totalSize}
            setFiles={setFiles}
            setTotalSize={setTotalSize}
          />
        </Grid>
      ))}
    </>
  );
};

export default AttachmentListSection;
